import { DEFINITIONS } from 'videocontext'
import BaseNode from './BaseNode'
import EffectNode from './EffectNode'

export default class OutputNode extends BaseNode {
  constructor (context) {
    super(context, null, [], [])
    this._type = 'Output'
    this._node = this._context.destination
  }
}


// WEBPACK FOOTER //
// ./src/Video/OutputNode.js